document.addEventListener("DOMContentLoaded", function () {
  const enquiryDropdown = document.querySelector('select[name="contact[type-of-enquiry]"]');
  const fileUploadBlock = document.querySelector('.fileupload');
  const calendarBlock = document.querySelector('.calendar');

  if (!enquiryDropdown) return;

  function setBlockInputs(block, enabled) {
    if (!block) return;

    block.querySelectorAll('input, select, textarea').forEach((input) => {
      if (enabled) {
        input.disabled = false;
        return;
      }

      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false;
      } else {
        input.value = '';
      }

      input.disabled = true;
    });
  }

  function toggleWarrantyFields() {
    const showFields = enquiryDropdown.value === "Warranty Claim";

    if (fileUploadBlock) fileUploadBlock.style.display = showFields ? "block" : "none";
    if (calendarBlock) calendarBlock.style.display = showFields ? "block" : "none";

    setBlockInputs(fileUploadBlock, showFields);
    setBlockInputs(calendarBlock, showFields);
  }

  toggleWarrantyFields();
  enquiryDropdown.addEventListener("change", toggleWarrantyFields);
});
